type Name = { url: string; displayName: string };

export const EXPECTATIONS_OVERVIEW: Name = { url: 'expectations-overview', displayName: 'Expectations Overview' };
export const FRESHNESS: Name = { url: 'freshness', displayName: 'Freshness' };

export default {
	EXPECTATIONS_OVERVIEW,
	FRESHNESS,
};
